import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

export const workflowStatusValidator = yupResolver(
  yup.object().shape({
    status: yup.object().nullable().required("Please select status"),
    type: yup.object().nullable().required("Please select type"),
  }),
);
